export default __webpack_public_path__ + "static/media/18.fded4421.jpg";